function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#222428;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M155.4,39.5V29.1c0-2.2-1.8-3.9-3.9-3.9h-15.9L105.7,3.4c-6.3-4.5-15.7-4.5-22,0L53.8,25H37.9 c-2.2,0-3.9,1.8-3.9,3.9v10.6l-31,22.6c-1,0.8-1.6,2-1.6,3.1v95.9c0,1,0.4,2.2,1.2,2.8c0.8,0.8,1.8,1.2,2.8,1.2H184 c2.2,0,3.9-1.8,3.9-3.9c0,0,0-91.9,0-92.9s0-4.5-2.6-6.5C183.1,60,170.7,50.7,155.4,39.5z M64,113.2L9.2,153.5V73.1L64,113.2z  M70.7,118.1L92.3,134c0.8,0.6,1.6,0.8,2.4,0.8s1.6-0.2,2.4-0.8l21.6-15.9l53.2,39.3H17.5L70.7,118.1z M125.3,113.2l54.6-39.9v80.3 L125.3,113.2z M177.4,65.5l-22,16.1V49.4C164.6,56,172.6,61.9,177.4,65.5z M88.4,9.7c3.5-2.6,9.2-2.6,12.8,0c0,0,9,6.7,21,15.3 H67.4L88.4,9.7z M147.5,33.1v54.2l-52.8,38.5L41.8,87.3V33.1H147.5z M34,81.4L12,65.5l22-16.1V81.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M60.1,58.2h69.3c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H60.1c-2.2,0-3.9,1.8-3.9,3.9 C56,56.4,57.7,58.2,60.1,58.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M60.1,79h69.3c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H60.1c-2.2,0-3.9,1.8-3.9,3.9 C56,77.2,57.7,79,60.1,79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M112.5,92.2H76.8c-2.2,0-3.9,1.8-3.9,3.9c0,2.2,1.8,3.9,3.9,3.9h35.6c2.2,0,3.9-1.8,3.9-3.9 C116.5,93.9,114.7,92.2,112.5,92.2z"
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 189.3 166.9",
    style: {
      enableBackground: "new 0 0 189.3 166.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.25fb3994.svg";
export { ForwardRef as ReactComponent };